// Based on: https://github.com/pladaria/requestidlecallback-polyfill

export const requestIdleCallback =
  globalThis.requestIdleCallback ??
  ((callback: IdleRequestCallback) => {
    const start = Date.now();
    return setTimeout(() => {
      callback({
        didTimeout: false,
        timeRemaining: () => Math.max(0, 50 - (Date.now() - start)),
      });
    }, 1);
  });

export const cancelIdleCallback =
  globalThis.cancelIdleCallback ??
  ((id: number | string) => {
    clearTimeout(id);
  });

/** Installs the `requestIdleCallback` and `cancelIdleCallback` pollyfills. */
export const polyfillRequestIdleCallback = (): void => {
  globalThis.requestIdleCallback = requestIdleCallback;
  globalThis.cancelIdleCallback = cancelIdleCallback;
};
